import script from "./InstagramCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./InstagramCard.vue?vue&type=script&lang=ts&setup=true"

import "./InstagramCard.vue?vue&type=style&index=0&id=2359e256&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2359e256"]])

export default __exports__